export default __webpack_public_path__ + "static/media/indicator_carousel5.90ff9fbf.png";